module.exports = __webpack_public_path__ + "assets/-_2.b62c106d.svg";